import { useMemo } from 'react'
import { useSelector } from 'react-redux'

/**
 * Hook to check if current session has a valid user identifier (logged-in or guest)
 * @returns {{ userId: string|null, guestUserId: string|null, hasIdentifier: boolean }}
 */
export const useUserIdentifier = () => {
  const userId = useSelector(state => state.currentUser?.id)

  return useMemo(() => {
    const guestUserId = localStorage.getItem('guest_user_id')
    return {
      userId: userId || null,
      guestUserId,
      hasIdentifier: Boolean(userId || guestUserId)
    }
  }, [userId])
}
